module.exports = __webpack_public_path__ + "static/media/mine.c194f7fd.TTF";